// Shared by the Terms and the Privacy Policy.
//
// On purpose, the pages name no person and no hosting company: Fennira is an
// independent project and the contact point is the email address below. Don't
// add a name, an address or the host here without the owner's say-so.

export const CONTACT_EMAIL = "support@fennira.com";
export const LAST_UPDATED = "26 October 2026";
